import { Component, Input } from '@angular/core';
import { PanelMenuModule } from 'primeng/panelmenu';
import { MenuItem } from 'primeng/api';
import { Router } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { Observable } from 'rxjs';
import { SharedService } from 'src/app/core/shared/shared.service';
import { UserType } from 'src/app/core/enum/UserType';
@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [PanelMenuModule, ButtonModule],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss'
})
export class SidebarComponent {
  user$: Observable<any | null> | undefined;
  isLoginScreen = false
  @Input() isToggled: boolean = false;
  user: any;
  menuItems: MenuItem[] = [];
  constructor(private router: Router, private sharedService: SharedService) {}

  setMenuItems() {
    const users = [UserType.admin, UserType.landlord];
    if (users.includes(this.user?.user_type)) {
      this.menuItems = [
        { label: 'Dashboard', icon: 'pi pi-home', routerLink: '/dashboard' },
        { label: 'Tour', icon: 'pi pi-calendar-clock', routerLink: '/followups' },
        { label: 'Tenant Listing', icon: 'pi pi-users', routerLink: '/tenants' },
        {
          label: 'Property Management',
          icon: 'pi pi-building',
          items: [
            { label: 'Floor Plan', icon: 'pi pi-building', routerLink: '/floor-plans' },
            { label: 'Units', icon: 'pi pi-warehouse', routerLink: '/units-listing' },
            { label: 'Amenities', icon: 'pi pi-sitemap', routerLink: '/amenities' },
          ],
        },
        {
          label: 'Admin Listing', icon: 'pi pi-user-plus',
          items: [
            { label: 'Users', icon: 'pi pi-user-plus', routerLink: '/users' },
            { label: 'Chat', icon: 'pi pi-comments', routerLink: '/chat-bot-logs' },
            { label: 'SMS Test', icon: 'pi pi-send', routerLink: '/sms-test' },
            { label: 'Templates', icon: 'pi pi-file-check',
              items: [
                { label: 'To Resident', icon: 'pi pi-users', routerLink: '/templates/resident' },
                { label: 'To Lead', icon: 'pi pi-bookmark', routerLink: '/templates/lead' },
                { label: 'Resident and Lead', icon: 'pi pi-bookmark', routerLink: '/templates/both' },
                { label: 'New Lead - No Showing Scheduled', icon: 'pi pi-bell', routerLink: '/templates/external-lead' },
              ]
            },
          ],
        },
        { label: 'Property Info', icon: 'pi pi-building', routerLink: '/property-info' },
        { label: 'FAQ Management', icon: 'pi pi-list-check', routerLink: '/faq-management' },
        // { label: 'Prompts', icon: 'pi pi-building', routerLink: '/prompts' },
        { label: 'Availability', icon: 'pi pi-building', routerLink: '/availability' },
        { label: 'Reports', icon: 'pi pi-chart-bar', routerLink: '/reports' },
        { label: 'CRM', icon: 'pi pi-address-book', routerLink: '/crm' },
      ];
    }
    else if (this.user?.user_type === 'tenant') {
      this.menuItems = [
        { label: 'Dashboard', icon: 'pi pi-home', routerLink: '/tenants-portal' },
        { label: 'Tour', icon: 'pi pi-calendar-clock', routerLink: '/followups' },
        { label: 'Settings', icon: 'pi pi-cog', routerLink: '/tenant-settings' },
      ];
    }
  }

  ngOnInit() {
    this.isLoginScreen = window.location.href.includes('login') || window.location.href.includes('forgot-password');
    this.sharedService.currentUser$.subscribe(user => {
      this.user = user;
      this.setMenuItems();
    });
  }

  logout() {
    localStorage.removeItem('accessToken');
    this.router.navigate(['/login']);
  }
}
